import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TextAreaControl } from '../../../form-models/form-control-base';

@Component({
  selector: 'hb-df-textarea',
  templateUrl: './textarea.component.html',
})
export class TextareaComponent {
  @Input() control: TextAreaControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter();

  constructor() {}

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
